import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteTrainingType = (trainingTypeId) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.MANAGE.DELETE_TRAINING_TYPES(trainingTypeId)
  );
};

export default deleteTrainingType;
